import { render } from "./TypographyPage.vue?vue&type=template&id=7f4fb19e&ts=true"
import script from "./TypographyPage.vue?vue&type=script&lang=ts"
export * from "./TypographyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__